import React from "react";

const InvitationDialog = () => {
    return (
        <div></div>
    )
}

export default InvitationDialog;
